// We call the robot after Seb, the CLC compliance fellow. Ask Jamie about details why.
export const CRMSystemName = "Seb";
export const CRMSystemLastName = "The Robot";